"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Link_1 = __importDefault(require("atomicComponents/atoms/Text/Link"));
var ModalAlert_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlert"));
var SuccessAlertContent = function (_a) {
    var onClose = _a.onClose, rechCustomer = _a.rechCustomer;
    return ((0, jsx_runtime_1.jsx)(ModalAlert_1.default, { open: true, status: "success", title: "Agreement cancelled", onClose: onClose, textAlign: "left", description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We\u2019ve cancelled your agreement with ", (0, jsx_runtime_1.jsxs)("strong", { children: [rechCustomer.name, "."] }), " Quick access to:", (0, jsx_runtime_1.jsxs)("ul", __assign({ style: { marginBottom: 0 } }, { children: [(0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ inLine: true, to: "/recharges/mapping/all?filter[customerId]=".concat(rechCustomer.id) }, { children: "Customer Mapping" })) }), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ inLine: true, to: "/recharges/charges/all?filter[customerId]=".concat(rechCustomer.id) }, { children: "Charges" })) })] }))] })) }));
};
exports.default = SuccessAlertContent;
